import { render } from "./ClusterInTree.vue?vue&type=template&id=b5bcd8cc"
import script from "./ClusterInTree.vue?vue&type=script&lang=js"
export * from "./ClusterInTree.vue?vue&type=script&lang=js"
script.render = render

export default script